module.exports = __webpack_public_path__ + "media/images/athletes/2605-20ad571379bf121b8889dd22e80e3f58.png";